'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPlainObject = {};

exports.__exports = isPlainObject;
